// src/graphql/mutations/downloadMutations.js
// Request a tender document bundle (ZIP). Feature-gated (`tender_downloads`)
// and IP rate-limited (60/h) on the backend. Returns immediately — poll
// tenderDownload(id) until READY (builds typically finish in seconds).
// Repeat requests for an unchanged document set return the existing bundle.

export const requestTenderDownload = `mutation RequestTenderDownload($input: RequestTenderDownloadInput!) {
    requestTenderDownload(input: $input) {
        id
        tenderId
        flavor
        includesBidlyzerDocs
        status
        error
        createdAt
    }
}`;
